/**
 * Done. / ChiroCPD — BrandFooter
 *
 * "Powered by Done." — on EVERY page, non-negotiable brand requirement.
 * data-print-hidden so it doesn't appear in print/PDF exports.
 */

export function BrandFooter(): React.ReactElement {
  const year = new Date().getFullYear();

  return (
    <footer
      data-print-hidden
      className="mt-auto border-t border-[var(--border-subtle)] bg-[var(--surface-base)] py-4 px-4"
    >
      <div className="mx-auto max-w-5xl flex flex-col sm:flex-row items-center justify-between gap-2 text-xs text-[var(--text-muted)]">
        <p>
          Powered by{' '}
          <strong className="font-semibold text-[var(--color-done-700)]">Done.</strong>
        </p>
        <p>© {year} RED SKY 365 Limited. All rights reserved.</p>
      </div>
    </footer>
  );
}
